import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Pediatric Care",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/corporate_law_meeting.png",
  href: "/MembershipPage",
  titleClassName: "!bg-[url(https://fair-mollusk.10web.cloud/wp-content/uploads/2026/04/Kid-2-e1775154194501.png)] absolute bottom-0 left-0 w-full p-6 md:p-8 flex flex-col justify-end h-full z-10 !bg-[url(https://crescentdpc.com/wp-content/uploads/2026/04/Kid-2-e1775154194501.png)]"
}, {
  title: "Chronic Disease",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/intellectual_property_concept.png",
  href: "/MembershipPage",
  titleClassName: "!bg-[url(https://crescentdpc.com/wp-content/uploads/2026/04/intellectual_property_concept-e1775694061818.webp)] absolute bottom-0 left-0 w-full p-6 md:p-8 flex flex-col justify-end h-full z-10 !bg-[url(https://crescentdpc.com/wp-content/uploads/2026/04/intellectual_property_concept.webp)]"
}, {
  title: "Preventive Wellness",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/employment_labor_discussion.png",
  href: "/MembershipPage"
}, {
  title: "Urgent Access",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/real_estate_architecture.png",
  href: "/MembershipPage"
}, {
  title: "Women's Health",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/litigation_courtroom.png",
  href: "/MembershipPage",
  titleClassName: "!bg-[url(https://fair-mollusk.10web.cloud/wp-content/uploads/2026/04/Woman-Edit.png)] absolute bottom-0 left-0 w-full p-6 md:p-8 flex flex-col justify-end h-full z-10 !bg-[url(https://fair-mollusk.10web.cloud/wp-content/uploads/2026/04/woman-e1775154049912.png)]"
}, {
  title: "Geriatric Medicine",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/family_law_consultation.png",
  href: "/MembershipPage"
}, {
  title: "Mental Wellness",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/estate_planning_documents.png",
  href: "/MembershipPage"
}, {
  title: "View All Services",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615506/img/law_firm_library.png",
  href: "/MembershipPage",
  isAction: true
}];
export default function LegalExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="41532" id="comprehensive-family-services" className="bg-background py-20 px-4 overflow-hidden !text-[hsl(223,23%,43%)] md:py-32 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8 border-b border-border pb-8">
            <div className="max-w-2xl">
              <h2 className="text-sm font-mono tracking-widest uppercase mb-4 !text-[hsl(223,23%,43%)]">
                Continuity of Care
              </h2>
              <h3 className="text-4xl font-serif leading-tight !text-[hsl(223,23%,43%)] md:text-5xl">
                Personalized primary care for every stage of life.
              </h3>
            </div>
            <div className="max-w-md">
              <p className="text-muted-foreground text-lg leading-relaxed font-sans">
                Experience healthcare as it should be: transparent, accessible, and 
                centered around your unique well-being and long-term health.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {services.map((service, i) => <Link key={i} to={service.href} className="group block h-full w-full outline-none" data-index={i}>
                <Card className="relative h-[400px] md:h-[500px] w-full overflow-hidden rounded-xl border border-border/50 bg-card shadow-sm transition-shadow duration-500 group-hover:shadow-xl">
                  {}
                  <div className="absolute inset-0 w-full h-full">
                    <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-all duration-700 ease-out 
                        filter brightness-90
                        group-hover:scale-105 group-hover:brightness-100" />
                    {}
                    <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/20 to-transparent opacity-60 transition-all duration-500 group-hover:opacity-40 group-hover:bg-ring/10" />
                  </div>

                  {}
                  <CardContent className={`${service.titleClassName || ""} absolute bottom-0 left-0 w-full p-6 md:p-8 flex flex-col justify-end h-full z-10`}>
                    <div className="flex items-end justify-between w-full">
                      <h4 className="font-serif text-2xl md:text-3xl text-white leading-none tracking-tight max-w-[80%]">
                        {service.title}
                      </h4>
                      
                      {}
                      <div className="relative overflow-hidden w-8 h-8 flex items-center justify-center">
                        <ArrowRight className="text-primary-foreground w-6 h-6 absolute transition-all duration-500 ease-out
                            opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0" />
                      </div>
                    </div>
                    
                    {}
                    <div className="w-0 h-[1px] bg-primary-foreground mt-4 transition-all duration-700 ease-out group-hover:w-full" />
                  </CardContent>
                </Card>
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}